

















































import {
  computed,
  defineComponent,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';

import SmallDeliveryObject from '@/components/Report/SmallDeliveryObject.vue';
import CommonCheckboxIcon from '@/components/CommonCheckboxIcon.vue';

import getDeliveries from '@/gql/delivery/getDeliveries.gql';

import { PaginatorInfo } from '@/types/paginatorInfo';
import useDownloadReport from '@/useDownloadReport';

const Delivery = defineComponent({
  components: {
    SmallDeliveryObject,
    CommonCheckboxIcon,
  },
  setup() {
    const { getPDFReport } = useDownloadReport();
    const { route, routerPersist } = useRouter(['searchString']);
    const search = reactive({
      deliveryName: '',
      deliverySearchInput: '',
      pendingDeliverySearch: false,
      deliverySort: [{ column: 'urgentLevel', order: 'DESC' }],
      deliverySortInput: 'urgentLevel',
    });

    const sortDeliveryDisplay = ['ระดับความเร่งด่วน', 'หมายเลขรายการ', 'วันที่สั่งซื้อ'];
    const sortDeliveryList = ['urgentLevel', 'orderNumber', 'orderDate'];
    const deliveryNameSearchHandler = _.debounce(() => {
      search.pendingDeliverySearch = true;
      // routerPersist.query.push({
      //   name: route.value.name as string,
      //   /* eslint-disable */
      //   query: { ...route.value.query, qs_searchString: search.deliverySearchInput },
      //   /* eslint-enable */
      // });
      search.deliveryName = search.deliverySearchInput;
    }, 500);
    const deliverySortHandler = _.debounce(() => {
      search.pendingDeliverySearch = true;
      search.deliverySort = [{ column: search.deliverySortInput, order: 'DESC' }];
    }, 100);

    const deliveries: Ref<any> = ref([]);
    const deliveryPaginatorInfo: Ref<PaginatorInfo> = ref({
      currentPage: 1,
      perPage: 30,
    });
    const deliveriesPage = ref(1);
    const { result: getDeliveriesResult, loading: deliveriesLoading } = useQuery(getDeliveries, computed(() => {
      let page = deliveriesPage.value;
      if (search.pendingDeliverySearch) page = 1;
      return {
        page,
        filterDeliveryNoteId: null,
        // searchCustomerName: search.deliveryName !== '' ? `%${search.deliveryName}%` : undefined,
        searchOrderNumber: search.deliveryName !== '' ? `%${search.deliveryName}%` : undefined,
        orderBy: search.deliverySortInput !== '' ? search.deliverySort : undefined,
      };
    }), () => ({ fetchPolicy: 'cache-and-network' }));
    const deliveriesResult = useResult(getDeliveriesResult, [], (data) => data.deliveries);
    watch(() => deliveriesResult.value, (newVal, oldVal) => {
      if (!deliveriesLoading.value && newVal !== oldVal) {
        if (search.pendingDeliverySearch) {
          deliveries.value = [];
          deliveries.value = deliveriesResult.value.data;
          deliveriesPage.value = 1;
          search.pendingDeliverySearch = false;
        } else deliveries.value = [...deliveries.value, ...deliveriesResult.value.data];
        deliveryPaginatorInfo.value = deliveriesResult.value.paginatorInfo;
      }
    });
    function scrollDeliveriesAreaHandler(visible: any) {
      if (!(deliveriesLoading.value) && deliveryPaginatorInfo.value.lastPage > deliveriesPage.value && visible) {
        deliveriesPage.value += 1;
      }
    }

    const selectedDelivery: Ref<any> = ref({
      id: -1,
    });

    const selectedReport: Ref<any> = ref('PDF');
    const reportTypeList = {
      list: [
        'PDF',
        // 'XLS',
      ],
      icon: [
        '002',
        // '015',
      ],
    };

    return {
      search,
      deliveryNameSearchHandler,
      deliverySortHandler,

      deliveries,
      deliveriesLoading,
      deliveryPaginatorInfo,

      scrollDeliveriesAreaHandler,

      sortDeliveryDisplay,
      sortDeliveryList,

      selectedDelivery,
      getPDFReport,

      selectedReport,
      reportTypeList,
    };
  },
});

export default Delivery;
